let csrfToken = '';
let eventWriteQueue: Promise<unknown> = Promise.resolve();

export function setCsrfToken(value: string): void {
  csrfToken = value;
}

export class ApiError extends Error {
  constructor(public readonly code: string, message: string, public readonly status: number) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = (init.method ?? 'GET').toUpperCase();
  // 別カードの連続操作を順に送信し、同じ利用者の更新ロック競合を避ける。
  if (path.startsWith('/api/events/') && !['GET', 'HEAD'].includes(method)) {
    const pending = eventWriteQueue.then(() => request<T>(path, init));
    eventWriteQueue = pending.catch(() => undefined);
    return pending;
  }
  return request<T>(path, init);
}

async function request<T>(path: string, init: RequestInit, attempt = 0): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body) headers.set('content-type', 'application/json');
  if (csrfToken && !['GET', 'HEAD'].includes(init.method ?? 'GET')) headers.set('X-CSRF-Token', csrfToken);
  const response = await fetch(path, { ...init, headers, credentials: 'same-origin' });
  const payload = await response.json().catch(() => ({})) as T & { error?: { code: string; message: string } };
  // SHEET_BUSYは処理開始前の拒否なので、安全に再送できる。他の失敗は再送しない。
  if (path !== '/api/mailbox/retry' && response.status === 409 && payload.error?.code === 'SHEET_BUSY' && attempt < 4) {
    await new Promise((resolve) => setTimeout(resolve, 300 * 2 ** attempt));
    return request<T>(path, init, attempt + 1);
  }
  if (!response.ok) throw new ApiError(payload.error?.code ?? 'REQUEST_FAILED', payload.error?.message ?? '通信に失敗しました', response.status);
  return payload;
}
